import { useCallback, useState } from 'react';

export const useMasterIndexRowMenu = <T>() => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [selectedItem, setSelectedItem] = useState<T | null>(null);

  const handleOpenMenu = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>, item: T) => {
      event.stopPropagation();
      setAnchorEl(event.currentTarget);
      setSelectedItem(item);
    },
    [],
  );

  const handleCloseMenu = useCallback(() => {
    setAnchorEl(null);
    setSelectedItem(null);
  }, []);

  return {
    anchorEl,
    selectedItem,
    handleOpenMenu,
    handleCloseMenu,
  };
};

export default useMasterIndexRowMenu;
